import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserManagementRoutingModule } from './user-management-routing.module';
import { UserManagementParentComponent } from './user-management-parent/user-management-parent.component';
import { UserManagementFormComponent } from './user-management-form/user-management-form.component';
import { FormsModule } from '@angular/forms';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { UserManagementEditorComponent } from './user-management-editor/user-management-editor.component';
import { AddUserComponent } from './add-user/add-user.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    UserManagementParentComponent,
    UserManagementFormComponent,
    UserManagementEditorComponent,
    AddUserComponent
  ],
  imports: [
    CommonModule,
    UserManagementRoutingModule,
    FormsModule,
    SharedComponentsModule,
    ReactiveFormsModule
  ]
})
export class UserManagementModule { }
